import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { grpc } from '@improbable-eng/grpc-web';

import {
  GetPeriodsRequest,
  GetPeriodsResponse,
} from '../period/period_pb';

import {
  PeriodManager as __PeriodManager,
} from '../period/period_pb_service';

@Injectable({providedIn: 'root'})
export class PeriodManager {

  constructor(private _ngZone: NgZone) {
  }

  getPeriods(request: GetPeriodsRequest): Promise<GetPeriodsResponse>;
  getPeriods(request: GetPeriodsRequest, metadata: grpc.Metadata): Promise<GetPeriodsResponse>;
  getPeriods(request: GetPeriodsRequest, callback: (err: any|null, response: GetPeriodsResponse, metadata: grpc.Metadata) => void): void;
  getPeriods(request: GetPeriodsRequest, metadata: grpc.Metadata, callback: (err: any|null, response: GetPeriodsResponse, metadata: grpc.Metadata) => void): void;

  getPeriods(request: GetPeriodsRequest, arg1?: grpc.Metadata|((err: any|null, response: GetPeriodsResponse, metadata: grpc.Metadata) => void), arg2?: (err: any|null, response: GetPeriodsResponse, metadata: grpc.Metadata) => void): Promise<GetPeriodsResponse>|void {
    let ret: any;
    let callback: any;
    let metadata: any;

    if(typeof arg1 === 'function') {
      callback = arg1;
    } else {
      metadata = arg1;
      callback = arg2;
    }

    if(!callback) {
      ret = new Promise<GetPeriodsResponse>((resolve, reject) => {
        callback = (err: any, response: any) => {
          if(err) reject(err);
          else resolve(response);
        };
      });
    }

    let responseMetadata: grpc.Metadata|null = null;

    let req = grpc.invoke(__PeriodManager.GetPeriods, {
      request: request,
      host: (<any>window).DEFAULT_ANGULAR_GRPC_HOST || 'https://' + location.hostname,
      metadata: metadata,
      onHeaders: headers => responseMetadata = headers,
      onMessage: response => this._ngZone.run(() => {
        callback(null, response, responseMetadata || new grpc.Metadata());
      }),
      onEnd: (code, msg, metadata) => this._ngZone.run(() => {
        if(code != grpc.Code.OK) {
          let err = new Error(msg);
          (<any>err).code = code;
          callback(err);
        }
      })
    });

    (<any>ret).cancel = () => req.close();
    return ret;
  }

}

